import BottomCardInt from "../components/BottomCardInt/BottomCardInt";
import React, {useEffect, useState} from "react";
import './BottomCardGroupInt.css'
import {cosmosTrackService} from "../../../cosmosTracking/cosmosTrackService";
import {
    ai_convert_banner,
    doubt_mate_banner,
    doubt_mate_request_callback,
    money_back_banner,
    money_back_request_callback,
    sale_video_doubt_mate,
    sale_video_super_sets,
    sale_video_tutor,
    sale_video_tutor_doubt_mate,
    sale_video_tutor_super_sets,
    super_sets_banner,
    super_sets_request_callback
} from "../../../cosmosTracking/cosmosEvents";
import baseURLGlobal from "../../../utils/util";

function BottomCardGroupInt(props){
    const [openSuperSetPopUp, setOpenSuperSetPopUp] = useState(false);
    const [openDoubtMatePopUp, setOpenDoubtMatePopUp] = useState(false);
    const [showThanksModal, setShowThanksModal] = useState(false);

    const baseUrl = baseURLGlobal;
    let url = new URL(window.location.href);
    let token = localStorage.getItem('campaignToken');

    const trustedOrigin = "https://campaigns.classplus.co";

    const handleCardFun = (item)=> {
        window.parent.postMessage({ type: "superSetOpened" }, trustedOrigin);
        if(item?.id === 1){
            setOpenSuperSetPopUp(true);
            cosmosTrackService('saleFeatureOne', {
                screen: 'EntryPoint',
                featureName: 'MoneyBack',
            });
        }
        else if(item?.id === 2){
            setOpenDoubtMatePopUp(true);
            cosmosTrackService('saleFeatureTwo', {
                screen: 'EntryPoint',
                featureName: 'MarketWatch',
            });
        }
    }
    const requestCallbackFun = (type)=>{
        if(type === "superSet") {
            cosmosTrackService('saleFeatureOne', {
                screen: 'RequestCallback',
                featureName: 'MoneyBack',
            });
        }
        else if(type === "doubtMate"){
            cosmosTrackService('saleFeatureTwo', {
                screen: 'RequestCallback',
                featureName: 'MarketWatch',
            });
        }
        callbackAPIFun(type);
        setOpenDoubtMatePopUp(false);
        setOpenSuperSetPopUp(false);
        setShowThanksModal(true);
    }
    const popupClosedFun = function (){
        setOpenDoubtMatePopUp(false);
        setOpenSuperSetPopUp(false);
        window.parent.postMessage({ type: "modalClosed" }, trustedOrigin);
    }
    const hideShowThanksModal = function (){
        setShowThanksModal(false);
    }

    const callbackAPIFun  = (type)=> {
        var myHeaders = new Headers();
        myHeaders.append('x-access-token', token);
        myHeaders.append('Content-Type', 'application/json');

        const raw = JSON.stringify({
            "statType": type === "superSet" ? 20 : 17,
            ...(type === "superSet" ? { superSetRequested: 1 } : { aiConvertCallBackRequested: 1 })
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: raw
        };

        fetch(`${baseUrl}/v2/course/campaign/update`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                console.log(result); // Handle the response
            })
            .catch((error) => {
                console.error('Error:', error); // Handle errors
            });
    }
    return(
        <>
            <div className="bottomCardGroup">
                {props?.bottomCard?.map((item, i)=>{
                    const isSuperSetDisabled = props?.campaignOrg?.superSetRequested === 1 && item?.id === 1;
                    const isAIConvertDisabled = props?.campaignOrg?.aiConvertCallBackRequested === 1 && item?.id === 2;
                    return (
                        <div className={`${isSuperSetDisabled || isAIConvertDisabled ? 'bottomCardDisable' : ''}`}
                            key={i}
                            onClick={() => handleCardFun(item)}>
                            <BottomCardInt cardData={item} key={i}></BottomCardInt>
                        </div>
                    )
                })}
            </div>

            {openSuperSetPopUp &&
                <div className="campaignPopUp">
                    <div className="campaignPopUpContent">
                        <div className="campaignPopUpHeader">
                            <h4>Happy Holi Sale 2026</h4>
                            <button onClick={popupClosedFun}>
                                <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/modal-close-icon.png" width={24} alt="icon"/>
                            </button>
                        </div>
                        <div className="campaignPopUpBody">
                            <div className="campaignPopUpTitle">Earn 3x Through Money back</div>
                            <video className="campaignPopUpVideo campaignPopUpVideoSuperSet"
                                   poster="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-money-back-poster.jpg"
                                   src=""
                                   controls={false} controlsList="nofullscreen nodownload noplaybackrate"
                                   disablePictureInPicture playsInline
                                   onPlay={() => cosmosTrackService(sale_video_tutor)}></video>
                            <div className="campaignPopUpHelper">
                                Boost Your Course Sales and Student Confidence with Our New 100% Money-Back Guarantee
                                Program!
                            </div>
                            <div className="campaignPopUpHelper">
                                Attract more students and increase your credibility by offering a risk-free learning
                                experience. With our new 100% Money-Back Guarantee Program, students can purchase select
                                courses with complete peace of mind. If they're not satisfied, they can claim a full
                                refund within 15 days. This innovative feature will not only boost your course sales but
                                also enhance student satisfaction and trust. Let Classplus handle the refund process, so
                                you can focus on creating exceptional content.
                            </div>
                            {/*<div className="campaignPopUpTitle campaignPopUpTitleSmall">See how Super Set feature changed their lives</div>*/}
                            {/*<img className="sale3xGainerImg" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-popup-poster-img.png" alt="gyanliveposter"/>*/}
                        </div>
                        <div className="campaignPopUpFooter">
                            <button onClick={() => requestCallbackFun("superSet")}>
                                Request callback
                            </button>
                        </div>
                    </div>
                </div>
            }
            {openDoubtMatePopUp &&
                <div className="campaignPopUp">
                    <div className="campaignPopUpContent">
                        <div className="campaignPopUpHeader">
                            <h4>Happy Holi Sale 2026</h4>
                            <button onClick={popupClosedFun}>
                                <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/modal-close-icon.png" width={24} alt="icon"/>
                            </button>
                        </div>
                        <div className="campaignPopUpBody">
                            <div className="campaignPopUpTitle">Give Your Students an Edge in the Stock Market!</div>
                            <video className="campaignPopUpVideo campaignPopUpVideoDoubtMate"
                                   poster="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/market-watch-banner.jpg"
                                   src=""
                                   controls={false} controlsList="nofullscreen nodownload noplaybackrate"
                                   disablePictureInPicture playsInline
                                   onPlay={()=>cosmosTrackService(sale_video_tutor)}></video>
                            <div className="campaignPopUpHelper">
                                Market Watch is the perfect way to keep your students ahead in the stock market. Every day, they’ll receive updates on key stocks, covering recent activities like acquisitions, business updates, big orders, market trends, stock performance, and company news—delivered straight to their WhatsApp. This turns theoretical knowledge into real-world understanding, making learning more practical and engaging.

                                For you, it’s a hassle-free way to stand out, attract more students, and boost retention. Just enable Market Watch, and we’ll take care of everything!

                                Help your students stay informed and confident while growing your revenue. Enable Market Watch today!
                            </div>
                        </div>
                        <div className="campaignPopUpFooter">
                            <button onClick={()=>requestCallbackFun("doubtMate")}>
                                Request callback
                            </button>
                        </div>
                    </div>
                </div>
            }
            {showThanksModal &&
                <div className="campaignPopUp campaignPopUpThanks">
                    <div className="campaignPopUpContent">
                        <div className="campaignPopUpBody">
                            <img src="https://ali-cdn-cp-assets-public.classplus.co/web/courseWebview/content/checkOk.gif" width={140} alt="okay"/>
                            <h4>Thank you for your interest!</h4>
                            <p>Your account manager will be in touch with you shortly.</p>
                            <button onClick={hideShowThanksModal}>Go back</button>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default BottomCardGroupInt;
